import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { listMcpTokens } from '../../../types'
import { actionApiCall } from '../api/actionApiCall'

export const mcpTokensQueryKey = ['mcp-tokens'] as const

/** Přístupové tokeny přihlášeného uživatele pro AI asistenta. */
export function useMcpTokens() {
    return useQuery({
        queryKey: mcpTokensQueryKey,
        queryFn: () => actionApiCall(() => listMcpTokens()),
    })
}

export function useInvalidateMcpTokens() {
    const queryClient = useQueryClient()
    return useCallback(() => queryClient.invalidateQueries({ queryKey: mcpTokensQueryKey }), [queryClient])
}
